import { m } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';
import Image from '#/components/shared/ui/Image';
import MotionContainer from '#/components/shared/animate/MotionContainer';
import { varBounce } from '#/components/shared/animate/variants';
import Page from '#/components/shared/ui/Page';

export default function Page403() {
  return (
    <Stack
      sx={{
        py: 12,
        maxWidth: 400,
        textAlign: 'center',
        m: 'auto',
        minHeight: '100vh',
        justifyContent: 'center',
      }}
    >
      <Page title="403">
        <MotionContainer>
          <m.div variants={varBounce().in}>
            <Typography variant="h3" paragraph>
              No permission
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <Typography sx={{ color: 'text.secondary' }}>
              The page you&apos;re trying access has restricted access.
              <br />
              Please refer to your system administrator
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <Image
              sx={{ my: { xs: 5, sm: 10 } }}
              src="/assets/icons/403.svg"
              alt="403"
            />
          </m.div>

          <Button
            component={RouterLink}
            to="/"
            size="large"
            variant="contained"
          >
            Go to Home
          </Button>
        </MotionContainer>
      </Page>
    </Stack>
  );
}
